import React from 'react'
import CreateNewSupplyOrderButton from './createNewOrder/CreateNewSupplyOrderButton'
import AddSupplyOrderBillButton from './addBill/AddSupplyOrderBillButton'
import AgreeDirectorButton from './agreeDirector/AgreeDirectorButton'

const SupplyOrderItemsActions = ({ supplyOrderId, checked, setChecked }) => {
  return (
    <>
        {
            checked && Object.keys(checked).length > 0 ?
                <div className='supplyOrderView__actions'>
                    <CreateNewSupplyOrderButton 
						supplyOrderId={supplyOrderId}
						checked={checked}
						setChecked={setChecked}
                    />
                    <AddSupplyOrderBillButton 
						supplyOrderId={supplyOrderId}
						// supplyOrderItems={supplyOrderItems}
						checked={checked}
						setChecked={setChecked}
					/>
                    <AgreeDirectorButton 
						supplyOrderId={supplyOrderId}
						// supplyOrderItems={supplyOrderItems}
						checked={checked}
						setChecked={setChecked}
					/>
                </div>
            : ''
        }
    </>
  )
}

export default SupplyOrderItemsActions